import { useState } from "react";
import Lightbox from "yet-another-react-lightbox";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/thumbnails.css";
const aadyaRoomImages = [
  "/images/Finalized photos/Edited/DSC01386.webp",
  "/images/Finalized photos/Edited/DSC01397.webp",
  "/images/Finalized photos/Edited/DSC01370.webp",
  "/images/Finalized photos/Edited/DSC01898.webp",
  "/images/Finalized photos/Edited/DSC01518.webp",
  "/images/Finalized photos/Edited/DSC01706.webp"
];
const AadyaRooms = () => {
  const [isGalleryOpen, setIsGalleryOpen] = useState(false);
  return <section className="w-full bg-white py-16 sm:py-20 lg:py-28">
            <div className="container mx-auto px-4 sm:px-6 lg:px-8">
                <div className="mx-auto max-w-3xl text-center">
                    <p className="font-mulish text-sm font-semibold uppercase tracking-[0.3em] text-amber-800">
                        Zimmer in Hiru Aadya
                    </p>
                    <h2 className="mt-5 font-serif text-3xl font-light leading-tight tracking-tight text-[#1f4d3c] sm:text-4xl lg:text-5xl">
                        Doppelzimmer mit Meerblick in allen Zimmern
                    </h2>
                    <p className="mt-5 font-mulish text-base leading-8 text-gray-600 sm:text-lg">
                        Genießen Sie in allen 11 eleganten Zimmern einen ruhigen Aufenthalt mit Blick auf den Indischen Ozean.
                    </p>
                </div>

                <article className="mx-auto mt-12 grid max-w-7xl overflow-hidden rounded-[26px] bg-[#fbfaf7] shadow-[0_22px_65px_rgba(16,38,26,0.1)] lg:grid-cols-[1.1fr_0.9fr]">
                    <button
    type="button"
    className="group relative block aspect-[4/3] min-h-[320px] w-full overflow-hidden bg-[#f3eee7] text-left lg:aspect-auto lg:min-h-[560px]"
    onClick={() => setIsGalleryOpen(true)}
    aria-label="Bilder des Doppelzimmers in Hiru Aadya ansehen"
  >
                        <img
    src={aadyaRoomImages[0]}
    alt="Doppelzimmer in Hiru Aadya"
    className="object-cover transition-transform duration-700 group-hover:scale-[1.04]" style={{ position: "absolute", inset: 0, width: "100%", height: "100%" }} loading="lazy" />
                        <div className="absolute inset-0 bg-gradient-to-t from-[#07130d]/75 via-transparent to-transparent" />
                        <div className="absolute inset-x-6 bottom-6 flex items-end justify-between gap-4 text-white sm:inset-x-8">
                            <div>
                                <p className="font-mulish text-xs font-semibold uppercase tracking-[0.22em] text-amber-200">11 Zimmer</p>
                                <h3 className="mt-2 font-serif text-3xl font-semibold sm:text-4xl">Doppelzimmer</h3>
                            </div>
                            <span className="rounded-full bg-white/20 px-3 py-2 text-xs font-semibold backdrop-blur-md">Bilder ansehen</span>
                        </div>
                    </button>

                    <div className="p-6 sm:p-8 lg:p-10">
                        <p className="font-mulish text-[15px] leading-8 text-gray-700 sm:text-base">
                            In Hiru Aadya gibt es 11 Zimmer, und alle verfügen über einen Balkon oder eine Terrasse mit Meerblick. Die großzügigen Innenräume von etwa 38 m² sind modern und angenehm eingerichtet und mit stilvoller Einrichtung ausgestattet.
                        </p>
                        <ul className="mt-6 space-y-2 border-l-2 border-amber-300 pl-4 font-mulish text-sm leading-7 text-[#475569] sm:text-base">
                            <li>Zimmerausstattung: Deckenventilator, Klimaanlage und Moskitonetz inklusive.</li>
                            <li>Komfort: Dusche und WC, Föhn, Safe, Telefon und kostenloses WLAN.</li>
                            <li>1. Etage (Erdgeschoss): 4 Zimmer / 2. Etage (1. Obergeschoss): 7 Zimmer.</li>
                        </ul>
                        <button
    type="button"
    onClick={() => setIsGalleryOpen(true)}
    className="mt-7 inline-flex items-center rounded-full bg-[#F28600] px-5 py-3 font-mulish text-sm font-semibold text-white shadow-lg shadow-[#f28600]/20 transition hover:bg-[#d67000]"
  >
                            Zimmerfotos ansehen
                        </button>
                    </div>
                </article>
            </div>

            <Lightbox
    open={isGalleryOpen}
    close={() => setIsGalleryOpen(false)}
    slides={aadyaRoomImages.map((image) => ({ src: image }))}
    plugins={[Thumbnails, Zoom]}
    thumbnails={{ position: "bottom", border: 0, vignette: true }}
    zoom={{ maxZoomPixelRatio: 3 }}
    carousel={{ finite: false }}
  />
        </section>;
};
export default AadyaRooms;
